import EBTPaymentFlow from './EBTPaymentFlow';

export default EBTPaymentFlow;
